import { CSSProperties, ReactNode } from 'react';

interface PermissionColumnsListProps<T> {
  items: readonly T[];
  renderItem: (item: T) => ReactNode;
  getKey: (item: T) => string;
}

/**
 * Renders permission rows in ladder order down the first column, then the second.
 * Uses column-first grid flow at the `md` breakpoint; stacks in natural order on narrow viewports.
 */
const PermissionColumnsList = <T,>({ items, renderItem, getKey }: PermissionColumnsListProps<T>) => {
  const rowCount = Math.ceil(items.length / 2);
  const gridStyle = {
    gridTemplateRows: `repeat(${rowCount}, minmax(0, auto))`,
  } as CSSProperties;

  return (
    <div
      className="grid gap-4 grid-cols-1 grid-flow-row md:grid-cols-2 md:grid-flow-col md:auto-rows-min"
      style={gridStyle}
    >
      {items.map((item) => (
        <div key={getKey(item)}>{renderItem(item)}</div>
      ))}
    </div>
  );
};

export default PermissionColumnsList;
